// @flow
import type { TimeZoneName } from 'src/types/Id';

const TimeZone = Object.freeze({
    AMERICA_MONTERREY: (('America/Monterrey': any): TimeZoneName),
    EUROPE_STOCKHOLM: (('Europe/Stockholm': any): TimeZoneName),
});
export default TimeZone;
